import { Block, Divider, useStyletron } from "@mezo-org/mezo-clay"

import { selectWalletBalances, useDappSelector } from "#/redux-state"
import { useMinimumNetDebt, useRepayBorrowAmount } from "#/shared/hooks"
import { bigIntToFloat, separateThousandsWithComma } from "#/shared/utils"
import { AmountInput } from "#/ui/Input"

import { BorrowReviewListItem } from "../components"

export default function RepayAmount() {
  const [css, theme] = useStyletron()
  const { MUSD } = useDappSelector(selectWalletBalances)

  const {
    hasBalanceError,
    repayLoanAmount,
    maxRepaymentAmountLabel,
    onRepayAmountChange,
    isRepayAmountValid,
    principalRepayAmountLabel,
    interestAmountLabel,
  } = useRepayBorrowAmount()

  const { minimumNetDebtLabel } = useMinimumNetDebt()

  return (
    <Block>
      <AmountInput
        label="Enter repayment amount"
        token="MUSD"
        placeholder="0 MUSD"
        unitLabel=" MUSD"
        autoFocus
        onChange={(ev) => onRepayAmountChange(ev.target.value)}
        value={repayLoanAmount}
        error={repayLoanAmount ? !isRepayAmountValid : false}
        hasBalanceError={hasBalanceError}
        infoMessage={`The minimum required loan balance is  ${minimumNetDebtLabel} MUSD.\nYou may make a partial repayment up to ${maxRepaymentAmountLabel} MUSD`}
        errorMessage={
          hasBalanceError
            ? "Invalid amount, insufficient funds"
            : `Adjust amount. Max partial repayment is ${maxRepaymentAmountLabel} MUSD`
        }
        balanceUsd={separateThousandsWithComma(repayLoanAmount) || "0.00"}
        balanceToken={bigIntToFloat(MUSD.balance, Number(MUSD.decimals), 2)}
      />
      <Block
        className={css({
          marginTop: theme.sizing.scale900,
          marginBottom: theme.sizing.scale800,
          border: `1px solid ${theme.colors.borderOpaque}`,
          borderRadius: theme.borders.radius300,
        })}
      >
        <BorrowReviewListItem
          header="Accrued interest"
          endHeader={`${interestAmountLabel} MUSD`}
          description="Deducted before reducing debt"
        />
        <Divider $size="cell" />
        <BorrowReviewListItem
          header="Net applied to debt"
          endHeader={`${principalRepayAmountLabel} MUSD`}
        />
      </Block>
    </Block>
  )
}
